module.exports = __webpack_public_path__ + "img/bg-congrats-3.48cd2963.svg";